// extracted by mini-css-extract-plugin
export default {"pdfDocumentWrapper":"_3a2326d1","pdfDocument":"_23c5a542"};